export default {
  CLEAR_DATA: Symbol('CLEAR_DATA'),
  SAVE_DATA: Symbol('SAVE_DATA'),
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  SET_PAGINATION: Symbol('SET_PAGINATION'),
  RESET_PAGINATION: Symbol('RESET_PAGINATION'),
  UPDATE_ID_VALIDATED_RES: Symbol('UPDATE_ID_VALIDATED_RES'),
  GUEST_LIST: Symbol('GUEST_LIST'),
  GET_CARD_PRICE: Symbol('GET_CARD_PRICE'),
  BUY_CARD: Symbol('BUY_CARD'),
  QUERY_SALES_PERSON: Symbol('QUERY_SALES_PERSON'),
  COUPON_LIST: Symbol('COUPON_LIST'),
  OPTIONAL_WANGYU_COUPON_LIST: Symbol('OPTIONAL_WANGYU_COUPON_LIST'),
  OPTIONAL_DOUYIN_COUPON_LIST: Symbol('OPTIONAL_DOUYIN_COUPON_LIST'),
  OPTIONAL_MANUAL_COUPON_LIST: Symbol('OPTIONAL_MANUAL_COUPON_LIST'),
  ACTIVITY_LIST: Symbol('ACTIVITY_LIST'),
  ACTIVITY_ORDER: Symbol('ACTIVITY_ORDER'),
  XUANZHU_COUPON_LIST: Symbol('XUANZHU_COUPON_LIST'),
  BUSINESS_PAYMENT_TYPE_LIST: Symbol('BUSINESS_PAYMENT_TYPE_LIST'),
  GUEST_KEYWORD_LIST: Symbol('GUEST_KEYWORD_LIST'),
  ACCOUNT_FLOW_LIST: Symbol('ACCOUNT_FLOW_LIST'),
  BASIC_CARD_INFO: Symbol('BASIC_CARD_INFO'),
  UPDATE_SENSITIZE_BASIC_INFO: Symbol('UPDATE_SENSITIZE_BASIC_INFO'),
  MEMBER_LEVEL_MAP: Symbol('MEMBER_LEVEL_MAP'),
  CHECKIN_HISTORY_PAGE_LIST: Symbol('CHECKIN_HISTORY_PAGE_LIST'),
  MEMBER_CARD_DETAIL: Symbol('MEMBER_CARD_DETAIL'),
  MEMBER_RECHARGE_DETAIL: Symbol('MEMBER_RECHARGE_DETAIL'),
};
